"use client";

import { Fragment, useState } from "react";

/* Compre Junto real da PDP da Larulp: seleção viva — marcar e
   desmarcar produtos recalcula o total na hora. */

const CDN = "https://cdn.shoppub.io/cdn-cgi/image";
const P = (path: string) =>
  `${CDN}/w=300,h=300,q=80,f=auto/larulp/media/uploads/produtos/foto/${path}`;

const ITENS = [
  {
    nome: "Camisa Winnie Movetech",
    preco: 699.9,
    foto: "shhrfhss/whatsapp-image-2026-08-20-at-084925-1.jpeg",
  },
  {
    nome: "Top Alana Basic Fit",
    preco: 189.9,
    foto: "vurmeccg/whatsapp-image-2026-08-20-at-084926.jpeg",
  },
  {
    nome: "Legging Doreen Basic Fit",
    preco: 299.9,
    foto: "hbyxyfqd/whatsapp-image-2026-08-20-at-084925-2.jpeg",
  },
];

const fmt = (v: number) =>
  v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export default function MockCompreJunto({ dark = false }: { dark?: boolean }) {
  const [sel, setSel] = useState([true, true, true]);
  const total = ITENS.reduce((s, it, i) => (sel[i] ? s + it.preco : s), 0);
  const qtd = sel.filter(Boolean).length;

  return (
    <div className="mt-8 max-w-lg select-none rounded-card border border-line bg-paper p-5 shadow-[0_24px_55px_-35px_rgba(10,10,11,0.4)]">
      <div className="text-[11px] font-bold uppercase tracking-wider text-smoke">
        Compre junto
      </div>
      <div className="mt-3 grid grid-cols-[1fr_auto_1fr_auto_1fr] items-start gap-2">
        {ITENS.map((it, i) => (
          <Fragment key={it.nome}>
            <button
              type="button"
              onClick={() => setSel(sel.map((s, d) => (d === i ? !s : s)))}
              aria-pressed={sel[i]}
              aria-label={`${sel[i] ? "Remover" : "Incluir"} ${it.nome}`}
              className="relative w-full min-w-0 cursor-pointer text-left"
            >
              <span
                className={`block overflow-hidden rounded-xl bg-mist transition ${
                  sel[i] ? "" : "opacity-45 grayscale"
                }`}
              >
                <img
                  src={P(it.foto)}
                  alt={it.nome}
                  loading="lazy"
                  className="aspect-[3/4] w-full object-cover"
                />
              </span>
              <span
                className={`absolute right-1.5 top-1.5 flex h-5.5 w-5.5 items-center justify-center rounded-full transition ${
                  sel[i] ? "bg-lime" : "border border-line bg-paper"
                }`}
              >
                {sel[i] && (
                  <svg viewBox="0 0 24 24" className="h-3 w-3" fill="none" stroke="#0a0a0b" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12.5l4.2 4.2L19 7" />
                  </svg>
                )}
              </span>
              <span className="mt-1.5 block truncate text-[11px] font-semibold leading-tight">
                {it.nome}
              </span>
              <span className="block text-[11px] text-smoke">{fmt(it.preco)}</span>
            </button>
            {i < ITENS.length - 1 && (
              <span className="self-center font-display text-lg font-bold text-smoke">+</span>
            )}
          </Fragment>
        ))}
      </div>
      <div className="mt-4 flex items-center justify-between gap-3 border-t border-line pt-3.5">
        <div>
          <div className="text-[11px] text-smoke">
            {qtd} {qtd === 1 ? "item" : "itens"}
          </div>
          <div className="font-display text-lg font-bold">{fmt(total)}</div>
        </div>
        <span
          className={`cursor-pointer rounded-full px-5 py-2.5 text-[13px] font-bold transition ${
            qtd > 0
              ? "bg-ink text-lime hover:bg-ink/85"
              : "cursor-not-allowed bg-mist text-smoke"
          }`}
        >
          Comprar junto
        </span>
      </div>
    </div>
  );
}
